import { useLocation, useNavigate } from 'react-router-dom'

const { DEBUG } = window.conf

// React Router navigate() that preserves the current URL's query string — used so e.g. ?from=manager survives in-app navigation
export const useNavigateWithQueryParams = () => {
    const { search } = useLocation()
    const navigate = useNavigate()

    return (path, options = {}) => {
        const pathWithQueryParams = `${path}${search}`
        const to = typeof path === 'string' ? pathWithQueryParams : path
        DEBUG && console.log(`[useNavigateWithQueryParams] Navigate to: ${pathWithQueryParams} (options: ${JSON.stringify(options)})`)
        navigate(to, options)
    }
}
